import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Redux/store/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { NotificationProvider } from "./contextApi/NotificationProvider";
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById("root"));
const clientId = process.env.REACT_APP_GOOGLE_CLIENTID;

root.render(
  <HelmetProvider>
    <React.StrictMode>
      <BrowserRouter>
        <GoogleOAuthProvider clientId={clientId}>
          <Provider store={store}>
            <NotificationProvider>
              <App />
            </NotificationProvider>
          </Provider>
        </GoogleOAuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  </HelmetProvider>
);

reportWebVitals();
